function titleClass({ row, column, rowIndex, columnIndex }) {
  let styleStr = "background:#E7E7E7;color:#4F4F4F;font-weight: bold;";
  return styleStr;
}
function rowClass({ row, column, rowIndex, columnIndex }) {
  if (columnIndex === 0) {
    return "padding-left:100px";
  } else {
    return "";
  }
}
function titleClassPadding({ row, column, rowIndex, columnIndex }) {
  let styleStr = "background:#D8D8D8;color:#595959;font-weight: bold;";
  if (columnIndex === 0) {
    styleStr += "padding-left:100px";
  }
  return styleStr;
}

function fileBaseUrl(){
  if (process.env.NODE_ENV === 'production') {
    return ""
  } else {
    return "/";
  }
}

function allYears(){
  let currentYear = new Date().getFullYear()
  let allYears = []
  for(let x = 0; x < currentYear-2019;x++){
    allYears.push(2020+x)
  }
  return allYears
}

function importBaseUrl(){
  if (process.env.NODE_ENV === 'production') {
    return ""
  } else {
    return "/";
  }

}

export default {
  titleClass, rowClass, titleClassPadding,fileBaseUrl,importBaseUrl,allYears
}